import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WGGameConfig} from "../../WGGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {TimelineLite, TimelineMax, TweenLite} from "gsap";
import {WGParsedInitData} from "../../server/data/WGParsedInitData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";

export class WGUpdateFreeSpinLeftMeter extends BaseView {

    private _fsmeterUpdateSpine: PIXI.spine.Spine;
    private _layer: ScalableLayer;
    private _fsMeterCountup: PIXI.BitmapText;
    private _fsRetriggedinFreespin: number;
    private _initDataParsed: boolean = false;
    private _resourcesloaded: boolean = false;
    private tl: TimelineMax;
    private _gameData: WGParsedInitData;

    protected initAnimations(): void {
        this.tl = new TimelineMax();
        //layer
        this._layer = StageManager.getLayer(WGGameConfig.instance.LAYERS.REEL_OVERLAY.name);
        // spine
        this._fsmeterUpdateSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("fs_mult_meter"));
        //countup
        this._fsMeterCountup = new PIXI.BitmapText("00", {
            fontName: "WGNumbersWinCountUp",
            fontSize: 13
        });
        this._fsMeterCountup.visible = false;
        this._fsmeterUpdateSpine.visible = false;
        this._fsMeterCountup.pivot.set(this._fsMeterCountup.width / 2, this._fsMeterCountup.height / 2);
        this._layer.addChild(this._fsmeterUpdateSpine, this._fsMeterCountup);
        // playing spine for the 1st time.
        new SpineTween(this._fsmeterUpdateSpine, 0, "fs_upgrade");
        this._resourcesloaded = true;
        this.updateFsCounteronRestore();
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => {
            // handle broken from here
            this._initDataParsed = true;
            this._gameData = event.params[0];
            this.updateFsCounteronRestore();
        });
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => {
            this._gameData = event.params[0];
        });
        EventHandler.addEventListener(this, SpinEvent.START, (event: GameEvent) => {
            this.decreaseFsMeterValue();
        });
    }

    /**
     * function to update fs meter on Restore
     */
    private updateFsCounteronRestore(): void {
        if (this._resourcesloaded && this._initDataParsed && this._gameData.isRestoreState) {
            this.resetMultipliers();
        }
    }

    /**
     * function will be called from intro continue pressup
     */
    public resetMultipliers(): void {
        this._fsMeterCountup.visible = true;
        this._fsmeterUpdateSpine.visible = true;
        this._fsMeterCountup.text = (this._gameData.freespinsLeft).toString();
        this._fsMeterCountup.text = this._fsMeterCountup.text.length < 2 ? "0" + this._fsMeterCountup.text : this._fsMeterCountup.text;
    }

    /**
     * function to decrease fs meter on spin start
     */
    private decreaseFsMeterValue() {
        let tl: TimelineLite = new TimelineLite();
        new SpineTween(this._fsmeterUpdateSpine, 0, "fs_downgrade");
        tl.add(() => {
            let value = ((Number(this._fsMeterCountup.text)) - 1).toString();
            this._fsMeterCountup.text = (value.length >= 2) ? value : ("0" + value);
        });
    }

    /**
     * increasing number of freespins  on reels stops if retriggered occured
     */
    public increaseFsMeterValueOnRetrigger(): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            new SpineTween(this._fsmeterUpdateSpine, 0, "fs_upgrade");
        });
        tl.add(() => {
            let value = ((Number(this._fsMeterCountup.text)) + 1).toString();
            this._fsMeterCountup.text = (value.length >= 2) ? value : ("0" + value);
            SlotGame.keypad.setZeroBetSpinCounter(Number(value)); // to fix #367
        }, 0.05);
        tl.add(TweenLite.fromTo(this._fsMeterCountup.scale, 0.1, {x: 1, y: 1}, {
            x: 1.5, y: 1.5, onComplete: () => {
                TweenLite.delayedCall(0.1, () => {
                    this._fsMeterCountup.scale.set(1);
                })
            }
        }), 0);
        return tl;
    }

    public hideFsmeterCountup(): void {
        this._fsMeterCountup.visible = false;
        this._fsmeterUpdateSpine.visible = false;
    }

    protected onResize(resizeData: IResizeData): void {
        let posX = WGGameConfig.instance.REEL_ENGINE_CONFIG.DIM.WIDTH * 6;
        if (resizeData.orientation === Orientation.LANDSCAPE) {
            this._fsmeterUpdateSpine.position.set(posX + 65, 240);
            this._fsMeterCountup.position.set(posX + 65, 230);
        } else {
            this._fsmeterUpdateSpine.position.set(posX * 0.65, 24);
            this._fsMeterCountup.position.set(posX * 0.65, 20);
        }
    }
}